import React, { useState } from 'react';
import { Modal, Button } from './UI';
import { DollarSign, Building2, User } from 'lucide-react';

const SOURCES = [
  { key:'pharmacy_cash',      label:'Pharmacy Cash',                  sub:'From pharmacy main balance',     icon:Building2, color:'blue'   },
  { key:'partner_halim',      label:'Abdul Halim Adib Karimi',        sub:'Partner contribution',            icon:User,      color:'green'  },
  { key:'partner_nuroollah',  label:'Nuroollah Mansoor',              sub:'Partner contribution',            icon:User,      color:'purple' },
];

export default function FundingSourceModal({ isOpen, onClose, onSelect, title = 'Select Funding Source' }) {
  const [selected, setSelected] = useState('pharmacy_cash');

  const handleConfirm = () => {
    const src = SOURCES.find(s => s.key === selected);
    onSelect({ key: selected, label: src?.label });
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <div className="space-y-3">
        <p className="text-sm text-gray-500">Who is paying for this expense?</p>
        {SOURCES.map(src => (
          <button key={src.key} type="button" onClick={() => setSelected(src.key)}
            className={`w-full flex items-center gap-3 p-3.5 rounded-xl border-2 text-left transition-all ${
              selected === src.key
                ? src.color === 'blue'   ? 'border-blue-500 bg-blue-50'
                : src.color === 'green'  ? 'border-green-500 bg-green-50'
                :                         'border-purple-500 bg-purple-50'
                : 'border-gray-200 bg-white hover:border-gray-300'
            }`}>
            <div className={`p-2 rounded-lg ${
              selected === src.key
                ? src.color === 'blue'   ? 'bg-blue-100'
                : src.color === 'green'  ? 'bg-green-100'
                :                         'bg-purple-100'
                : 'bg-gray-100'
            }`}>
              <src.icon size={18} className={
                selected === src.key
                  ? src.color === 'blue'   ? 'text-blue-600'
                  : src.color === 'green'  ? 'text-green-600'
                  :                         'text-purple-600'
                  : 'text-gray-400'
              }/>
            </div>
            <div>
              <p className="text-sm font-semibold text-gray-800">{src.label}</p>
              <p className="text-xs text-gray-400">{src.sub}</p>
            </div>
            {selected === src.key && (
              <div className="ml-auto w-5 h-5 rounded-full bg-blue-600 flex items-center justify-center">
                <span className="text-white text-xs">✓</span>
              </div>
            )}
          </button>
        ))}
        <div className="flex justify-end gap-2 pt-2">
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button onClick={handleConfirm}><DollarSign size={14}/> Continue</Button>
        </div>
      </div>
    </Modal>
  );
}
